export const getCookie = (cookieName: string): string | null => {
	if (typeof document === 'undefined') {
		return null
	}

	const regex = new RegExp(`(?:^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`)
	const match = regex.exec(document.cookie)
	return match ? match[1] : null
}
